import React, { useCallback, useEffect, useState } from 'react';

import styles from './Entry.module.scss';
import { Button, Col, Form, Input, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import routes from '../../router/routes';
import { useLoginMutation } from '../../store/apis/auth';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../store/slicers/auth';
import localforage from 'localforage';
import { executeRecaptcha, loadRecaptcha } from '../../recaptcha';

const RECAPTCHA_ACTION = 'staff_login_request';

const Entry = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [login, { isLoading: isLoginLoading }] = useLoginMutation();
  const [isRecaptchaLoading, setIsRecaptchaLoading] = useState(false);

  useEffect(() => {
    loadRecaptcha().catch((e) => console.log(e.message));
  }, []);

  const handleSubmit = useCallback(async (values) => {
    try {
      setIsRecaptchaLoading(true);
      const recaptcha = await executeRecaptcha(RECAPTCHA_ACTION).finally(() => setIsRecaptchaLoading(false));
      const credentials = await login({ ...values, recaptcha }).unwrap();
      dispatch(setCredentials(credentials));
      await localforage.setItem('credentials', credentials);
      navigate(routes.welcome());
    } catch (e) {
      console.log(JSON.stringify(e, 0, 2));
    }
  }, [dispatch, login, navigate]);

  return (
    <div className={styles.entry}>
      <Row
        justify="center"
        align="middle"
        className={styles.entryRow}
      >
        <Col sm={24} md={12} xl={8}>
          <div className={styles.entryWrapper}>
            <div className={styles.entryLogo}>
              <img src="/images/logo-rus.svg" alt=""  />
            </div>
            <Typography.Title level={4} type="secondary" className={styles.entryTitle}>
              {t('Панель для Администраторов')}
            </Typography.Title>

            <Form
              name="auth"
              layout="vertical"
              initialValues={{}}
              onFinish={handleSubmit}
              autoComplete="off"
              disabled={isLoginLoading || isRecaptchaLoading}
            >
              <Form.Item
                label={t('Логин')}
                name="username"
                rules={[
                  {
                    required: true,
                    message: t('Введите логин'),
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label={t('Пароль')}
                name="password"
                rules={[
                  {
                    required: true,
                    message: t('Введите пароль'),
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                wrapperCol={{
                  span: 24,
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={isLoginLoading || isRecaptchaLoading}
                >
                  {t('Войти')}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Entry;
